import React from 'react';
import './Cards.css';
import CardItem from './Carditem';

function Cards() {
  return (
    <div className='cards'>
      <h1>See how easy to list your shelter animals on Woof. </h1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              src='images/A1.jpg'
              text='Reach a wider audience on the internet for quicker adoptions.'
              path='/signup'
            />
            <CardItem
              src='images/A2.jpg'
              text='Let adpoters see information about your shelter animals at a glance to find their perfect match.'
              path='/signup'
            />
          </ul>
          <ul className='cards__items'>
            <CardItem
              src='images/A3.jpg'
              text='Quickly update pet profiles and easily remove after adoption.'
              path='/signup'
            />
            <CardItem
              src='images/D1.jpg'
              text='No other adoption website can match our success rate.'
              path='/signup'
            />
            <CardItem
              src='images/D5.jpg'
              text='Finding happy homes for pets is your passion. Its ours too.'
              path='/signup'
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;